/**
 * Moderation display helpers shared by the products table, the product detail
 * page, and the review queue.
 */

export type ModerationSeverityLevel = "high" | "medium" | "low";

export const SEVERITY_RANK: Record<string, number> = {
  high: 3,
  medium: 2,
  low: 1,
};

/** Highest severity across a set of violations; null when there are none. */
export function highestSeverity(
  violations: readonly { severity?: unknown }[],
): ModerationSeverityLevel | null {
  let best: ModerationSeverityLevel | null = null;
  let bestRank = 0;

  for (const violation of violations) {
    const severity = String(violation.severity ?? "").toLowerCase();
    const rank = SEVERITY_RANK[severity] ?? 0;
    if (rank > bestRank) {
      bestRank = rank;
      best = severity as ModerationSeverityLevel;
    }
  }

  return best;
}

export const SEVERITY_STYLES: Record<
  ModerationSeverityLevel,
  { readonly label: string; readonly badgeClass: string }
> = {
  high: {
    label: "High",
    badgeClass:
      "border-red-200 bg-red-50 text-red-700 dark:border-red-900 dark:bg-red-950/40 dark:text-red-300",
  },
  medium: {
    label: "Medium",
    badgeClass:
      "border-amber-200 bg-amber-50 text-amber-700 dark:border-amber-900 dark:bg-amber-950/40 dark:text-amber-300",
  },
  low: {
    label: "Low",
    badgeClass:
      "border-yellow-200 bg-yellow-50 text-yellow-700 dark:border-yellow-900 dark:bg-yellow-950/40 dark:text-yellow-300",
  },
};
